import React, { Component } from 'react';

import BudgetCategory from './budget-category';
import BudgetType from './budget-type';
import BudgetChart from './budget-chart';

class BudgetBlock extends Component {
  constructor(props) {
    super(props);
    this.renderGraphicalSymbols = this.renderGraphicalSymbols.bind(this);
  }
  renderGraphicalSymbols() {
    return (
      <div className="graphical-block">
        <div className="graphical-symbols">
          <div className="graphical-symbol">
            <i className="circle -a" aria-hidden="true" />
            <span className="description">可於政府資料開放平台data.gov.tw找到屬於縣市自己的資料集。</span>
          </div>
          <div className="graphical-symbol">
            <i className="circle -b"></i>
            <span className="description">僅可於縣市政府自建之資料開放平台找到相關資料</span>
          </div>
          <div className="graphical-symbol">
            <i className="circle -c"></i>
            <span className="description">僅能透過機關網站找到相關資訊，無開放資料</span>
          </div>
          <div className="graphical-symbol">
            <i className="circle -d"></i>
            <span className="description">尚無對外提供資訊</span>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div className="budget-block">
        <BudgetCategory />
        <BudgetType />
        <BudgetChart />
        {this.renderGraphicalSymbols()}
      </div>
    );
  }
}

export default BudgetBlock;



/** WEBPACK FOOTER **
 ** ./src/components/budget-block.js
 **/